import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';

const DividendsTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = useDividendsDistributionModal();

  return (
    <thead>
      <tr className="tb-tnx-head">
        <th className="nk-tb-col text-left">
          <span>{t('Name')}</span>
        </th>

        <th className="nk-tb-col text-right">
          <span>{t('%ND')}</span>
        </th>

        {data.hasRetention && (
          <th className="nk-tb-col text-right">
            <span>{t('GrossAmount')}</span>
          </th>
        )}

        <th className="nk-tb-col text-right">
          <span>{t('ToPerceive')}</span>
        </th>
      </tr>
    </thead>
  );
};

export default DividendsTableHeader;
